import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import SingleContent from 'components/common/layout/SingleContent';
import { Store } from 'components/common/types/Store.types';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getSetDetails } from 'store/pages/contentManagement/creativeSetDetails/actions';
import { resetCreativeSetDetails } from 'store/pages/contentManagement/creativeSetDetails/reducer';

import Header from './Header';
import PanelSet from './PanelSet';
import SetDetails from './SetDetails';
import VisualUnitsGroups from './VisualUnitGroups';

const CreativeSetDetails = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();
  const isPanelView = useSelector((state: Store) => state.pages.contentManagement.creativeSetDetails.isPanelView);

  useEffect(() => {
    if (id) dispatch(getSetDetails({ cancelFunctions, id }));
    return () => {
      dispatch(resetCreativeSetDetails());
    };
  }, []);

  return (
    <>
      <Header />
      {isPanelView || id ? <SingleContent content={<PanelSet />} /> : <VisualUnitsGroups />}
      {(isPanelView || id) && <SingleContent content={<SetDetails />} />}
    </>
  );
};

export default CreativeSetDetails;
